import Nickname from '../../Nickname';
import { useAuth } from '../../../../utils/Auth';
import Style from '../../Style';
import styles from './LinkedConfig.module.css';

export default function LinkedConfig() {
    const { qr_data, dataDispatch } = useAuth();

    return (
        <div className={styles.wrapper}>
            <div className={styles.section}>
                <div className={styles.sectionHeader}>
                    <h5 className={styles.sectionTitle}>Nickname</h5>
                    <p className={styles.sectionHint}>Name your linked QR so you can find it quickly.</p>
                </div>
                <div className={styles.sectionCard}>
                    <Nickname qr_data={qr_data} dataDispatch={dataDispatch} setUp />
                </div>
            </div>

            <div className={styles.section}>
                <div className={styles.sectionHeader}>
                    <h5 className={styles.sectionTitle}>Style</h5>
                    <p className={styles.sectionHint}>Adjust the look of the linked QR.</p>
                </div>
                <div className={styles.sectionCard}>
                    <Style />
                </div>
            </div>
        </div>
    );
};
